export function sanitizeHTML (data = '') {
  if (data === null) {
    data = ''
  }
  return data.replace(/(<([^>]+)>)/ig, '')
}
